import { useState } from "react";
import { useParams } from "react-router";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";

interface ArticleDetailsServiceType {
  article: any;
}

export default function ArticleDetailsService(): ArticleDetailsServiceType {
  const { axiosGetArticleById }: ArticleControllerType = ArticleController();
  const { showMessage, setBlockUI } = useAppContext();
  const [article, setArticle] = useState<any>([]);

  const { id }: any = useParams();

  useEffectOnce(() => {
    getArticleById();
  });

  const getArticleById = () => {
    setBlockUI(true);
    axiosGetArticleById(id)
      .then((result: any) => {
        setArticle(result.data);
        setBlockUI(false);
      })
      .catch((error: any) => {
        setBlockUI(false);
        handleErrorMessage(showMessage, error);
      });
  };

  return {
    article,
  };
}

export type { ArticleDetailsServiceType };
